import { changeShopPage } from 'constants/metric';
import pageNameSetter from 'decorator/pageNameSetter';

import VerifyDomain from './VerifyDomain';

export default pageNameSetter(changeShopPage.onboarding_create_campaign)(VerifyDomain);
